var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignalWifiOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.01 18.49L23.64 4C23.19 3.66 18.71 0 12 0C5.28 0 0.810001 3.66 0.360001 4L11.99 18.49L12 18.5L12.01 18.49Z",
    fill: "#323232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalWifiOn);
export default __webpack_public_path__ + "static/media/signal_wifi_on.7fe7a9d118ad00878bffbaf41d4568d1.svg";
export { ForwardRef as ReactComponent };